import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import useWindowDimensions from "../hooks/useWindowsDimensions";
import { IframeBlockerOverlay } from "./IframeBlockerOverlay";
import Swal from "sweetalert2";
import {
  gpsDeleteGeofence,
  gpsUpdateGeofence,
  insertNewGeofence,
} from "../utils/apiGpsGate.utils";

const MapEditGeofenceModal = ({
  title,
  modalIsClose,
  geoGroupList,
  drawRef,
  newPolygon,
  setNewPolygon,
  refreshGeofence,
  setRefreshGeofence,
  geofenceInfo,
  appGpsId,
  havePermissionDeleted
}) => {
  const [isMaxPage, setIsMaxPage] = useState(true);
  const [sizePage, setSizePage] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [position, setPosition] = useState({ x: 450, y: 100 });
  const modalRef = useRef(null);
  const offset = useRef({ x: 0, y: 0 });
  const dimensions = useWindowDimensions();
  const [resizeModalDimensions, setResizeModalDimensions] = useState({
    x: 450,
    y: 480,
  });
  const [isAutomaticSize, setIsAutomaticSize] = useState(false);
  const [resizing, setResizing] = useState({ active: false, direction: null });

  const [selectedGeoGroup, setSelectedGeoGroup] = useState(
    geofenceInfo.selectedGeoGroup
  );
  const [nameNewGeofence, setNameNewGeofence] = useState(
    geofenceInfo.geofenceName
  );
  const [descriptionNewGeofence, setDescriptionNewGeofence] = useState(
    geofenceInfo.description
  );

  const toRing = (coords) => {
    if (!coords || !Array.isArray(coords) || coords.length < 3) return null;
    let ring;
    ring = coords.map((v) => [Number(v.longitude), Number(v.latitude)]);
    return ring;
  };
  const geofence = toRing(geofenceInfo.vertices);

  const geofenceEdit = {
    id: "geofenceEdit",
    type: "Feature",
    properties: {},
    geometry: {
      type: "Polygon",
      coordinates: [geofence],
    },
  };

  useEffect(() => {
    if (drawRef.current && geofenceEdit) {
      drawRef.current.add(geofenceEdit);
      drawRef.current.changeMode("direct_select", {
        featureId: geofenceEdit.id
      });
    }
  }, []);

  useEffect(() => {
    if (modalRef.current) {
      const rect = modalRef.current.getBoundingClientRect();
      //setResizeModalDimensions({ x: rect.width, y: rect.height });
    }
  }, [isMaxPage]);

  useEffect(() => {
    if (dragging) {
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    } else {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [dragging, position]);

  useEffect(() => {
    if (resizing.active) {
      window.addEventListener("mousemove", handleMouseMoveResize);
      window.addEventListener("mouseup", onMouseUpResize);
    } else {
      window.removeEventListener("mousemove", handleMouseMoveResize);
      window.removeEventListener("mouseup", onMouseUpResize);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMoveResize);
      window.removeEventListener("mouseup", onMouseUpResize);
    };
  }, [resizing, position, resizeModalDimensions]);

  const onMouseDown = (e) => {
    offset.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };

    setDragging(true);
  };
  const onMouseMove = (e) => {
    if (!dragging || !isMaxPage) return;

    const leftX = e.clientX - offset.current.x;
    const leftY = e.clientY - offset.current.y;

    let maxX = dimensions.width - resizeModalDimensions.x - 50;
    const maxY = dimensions.height - resizeModalDimensions.y;

    const newX = Math.min(Math.max(leftX, 0), maxX);
    const newY = Math.min(Math.max(leftY, 0), maxY);

    setPosition({ x: newX, y: newY });
  };
  const onMouseDownResize = (direction) => {
    //console.log("Se presiona resize ", direction);
    setResizing({ active: true, direction });
  };

  const handleMouseMoveResize = (e) => {
    if (!resizing.active) return;

    const deltaX = e.movementX;
    const deltaY = e.movementY;

    let newWidth = resizeModalDimensions.x;
    let newHeight = resizeModalDimensions.y;
    let newX = position.x;
    let newY = position.y;

    if (resizing.direction === "R") {
      // Resizing to the right
      let auxDimensions = dimensions.width - position.x - 50;

      newWidth = Math.min(resizeModalDimensions.x + deltaX, auxDimensions);
      if (newWidth >= 400) {
        setResizeModalDimensions({ x: newWidth, y: newHeight });
      }
    } else if (resizing.direction === "B") {
      // Resizing to the bottom
      newHeight = Math.min(
        resizeModalDimensions.y + deltaY,
        dimensions.height - position.y
      );
      if (newHeight >= 400) {
        setResizeModalDimensions({ x: newWidth, y: newHeight });
      }
    } else if (resizing.direction === "L") {
      // Resizing to the left
      const nextWidth = resizeModalDimensions.x - deltaX;
      const nextX = position.x + deltaX;

      if (nextWidth > 400 && nextX >= 0) {
        // ancho mínimo = 100
        newWidth = nextWidth;
        newX = nextX;
        setResizeModalDimensions({ x: newWidth, y: newHeight });
        setPosition({ x: newX, y: newY });
      }
    } else if (resizing.direction === "T") {
      // Resizing to the top
      const nextHeight = resizeModalDimensions.y - deltaY;
      const nextY = position.y + deltaY;

      if (nextHeight > 400 && nextY >= 0) {
        // alto mínimo = 100
        newHeight = nextHeight;
        newY = nextY;
        setResizeModalDimensions({ x: newWidth, y: newHeight });
        setPosition({ x: newX, y: newY });
      }
    }
  };

  const onMouseUp = () => setDragging(false);
  const onMouseUpResize = () => setResizing({ active: false, direction: null });

  const closeModal = () => {
    //console.log("Entro a funcion");
    if (drawRef.current != null) {

      drawRef.current.deleteAll();
      setNewPolygon(null);
      modalIsClose(false);
    }
  };

  const handleGeofenceName = (event) => {
    setNameNewGeofence(event.target.value);
  };
  const handleGeofenceDescription = (event) => {
    setDescriptionNewGeofence(event.target.value);
  };
  const updateGeofence = async () => {
    console.log("entro a funcion updateGeofence");
    //console.log(nameNewGeofence);
    //console.log(descriptionNewGeofence);
    //console.log(selectedGeoGroup);
    //console.log(newPolygon);
    //console.log(geofenceInfo.vertices);

    var updateGeofenceVertices = null;
    if (newPolygon == null) {
      //console.log("Se debe asociar el poligono original");
      updateGeofenceVertices = geofenceInfo.vertices.map((c) => [
        c.longitude,
        c.latitude,
      ]);
    } else {
      var updateGeofenceVertices = newPolygon[0]?.geometry?.coordinates[0];
    }
    if (
      nameNewGeofence == null ||
      selectedGeoGroup == null ||
      updateGeofenceVertices == null ||
      geofenceInfo?.geofenceId == null
    ) {
      let result_error = await Swal.fire({
        title: "Conflicts when updating geofence",
        icon: "error",
        text: "All fields must be entered",
        confirmButtonColor: "#3085d6",
        customClass: {
          confirmButton:
            "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
        },
        buttonsStyling: false,
      });
    } else {
      var change_geo_group = false;
      if (geofenceInfo.selectedGeoGroup.value != selectedGeoGroup.value) {
        //console.log("Cambio el geogrupo");
        change_geo_group = true;
      } else {
        console.log("Se mantiene geogrupo");
      }

      const result = await Swal.fire({
        title: "Update geofence",
        text: "Do you want to update this geofence?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, save",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton:
            "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
          cancelButton:
            "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded ml-2",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        console.log("Se va a insertar geofence");
        const resultInsertNewGeofence = await gpsUpdateGeofence(
          appGpsId,
          geofenceInfo?.geofenceId,
          nameNewGeofence,
          descriptionNewGeofence,
          selectedGeoGroup?.value,
          updateGeofenceVertices,
          change_geo_group,
          geofenceInfo?.selectedGeoGroup.value
        );
        //console.log(resultInsertNewGeofence);
        //console.log(resultInsertNewGeofence.isUpdated);
        if (resultInsertNewGeofence.isUpdated == true) {
          let result_correct = await Swal.fire({
            title: "The Geofence was saved",
            icon: "success",
            confirmButtonColor: "#3085d6",
            customClass: {
              confirmButton:
                "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
            },
            buttonsStyling: false,
          });
          if (result_correct.isConfirmed) {
            setRefreshGeofence(!refreshGeofence);
            closeModal();
          }
        } else {
          let result_error = await Swal.fire({
            title: "The Geofence was not saved",
            icon: "error",
            confirmButtonColor: "#3085d6",
            customClass: {
              confirmButton:
                "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
            },
            buttonsStyling: false,
          });
        }
      }
    }
  };

  const deleteGeofence = async () => {
    console.log("entro a funcion deleteGeofence");
    //console.log(geofenceInfo.geofenceId);
    if (geofenceInfo?.geofenceId != null) {
      const result = await Swal.fire({
        title: "Delete geofence",
        text: "Do you want to delete this geofence?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton:
            "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
          cancelButton:
            "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded ml-2",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        console.log("Se va a eliminar");
        const resultDeleteGeofence = await gpsDeleteGeofence(
          appGpsId,
          geofenceInfo.geofenceId
        );
        //console.log(resultDeleteGeofence);
        if (resultDeleteGeofence.status == 200) {
          let result_correct = await Swal.fire({
            title: "The Geofence was deleted",
            icon: "success",
            confirmButtonColor: "#3085d6",
            customClass: {
              confirmButton:
                "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
            },
            buttonsStyling: false,
          });
          if (result_correct.isConfirmed) {
            setRefreshGeofence(!refreshGeofence);
            closeModal();
          }
        } else {
          let result_error = await Swal.fire({
            title: "The Geofence was not deleted",
            icon: "error",
            confirmButtonColor: "#3085d6",
            customClass: {
              confirmButton:
                "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
            },
            buttonsStyling: false,
          });
        }
      }
    }
  };

  return (
    <div>
      <div
        ref={modalRef}
        style={{
          left: position.x,
          top: position.y,
          zIndex: 10,
          width: isAutomaticSize ? undefined : `${resizeModalDimensions.x}px`,
          height: isAutomaticSize ? undefined : `${resizeModalDimensions.y}px`,
        }}
        className={`absolute bg-white rounded-lg shadow-lg w-full`}
      >
        <div
          className="absolute top-0 left-0 right-0 h-2 bg-white flex items-center justify-center cursor-row-resize"
          onMouseDown={() => onMouseDownResize("T")}
        >
          {resizing.active && <IframeBlockerOverlay />}
        </div>
        <div
          className="absolute bottom-0 left-0 right-0 h-2 bg-white flex items-center justify-center cursor-row-resize"
          onMouseDown={() => onMouseDownResize("B")}
        >
          {resizing.active && <IframeBlockerOverlay />}
        </div>
        <div
          className="absolute top-2 bottom-2 left-0 w-2 bg-white flex items-center justify-center cursor-col-resize"
          onMouseDown={() => onMouseDownResize("L")}
        >
          {resizing.active && <IframeBlockerOverlay />}
        </div>
        <div
          className="absolute top-2 bottom-2 right-0 w-2 bg-white flex items-center justify-center cursor-col-resize"
          onMouseDown={() => onMouseDownResize("R")}
        >
          {resizing.active && <IframeBlockerOverlay />}
        </div>
        <div
          className="flex justify-between items-center border-b p-4 flex-shrink-0 cursor-move"
          onMouseDown={onMouseDown}
        >
          {dragging && <IframeBlockerOverlay />}
          <div>
            <h2 className="text-xs font-semibold">{title}</h2>
          </div>
          <div>
            <button
              onMouseDown={(e) => e.stopPropagation()}
              className="text-gray-600 hover:text-gray-900 text-2xl font-bold mx-2"
            >
              -
            </button>
            <button
              onMouseDown={(e) => e.stopPropagation()}
              onClick={closeModal}
              className="text-gray-600 hover:text-gray-900 text-2xl font-bold mx-2"
            >
              &times;
            </button>
          </div>
        </div>
        <div class="mt-1 sm:mx-auto sm:w-full sm:max-w-sm bg-white p-2">
          <div>
            <label className="block text-sm/6 font-medium text-gray-900">
              Name
            </label>
            <div class="mt-2 mb-4">
              <input
                type="text"
                value={nameNewGeofence}
                onChange={handleGeofenceName}
                className="block w-full border-2 border-solid rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              />
            </div>
          </div>

          <div>
            <div>
              <label className="block text-sm/6 font-medium text-gray-900">
                Description
              </label>
            </div>
            <div className="mt-2 mb-4">
              <input
                type="text"
                value={descriptionNewGeofence}
                onChange={handleGeofenceDescription}
                class="block w-full border-2 border-solid rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              />
            </div>
          </div>

          <div>
            <div>
              <label className="block text-sm/6 font-medium text-gray-900">
                Group
              </label>
            </div>
            <div className="mt-2 mb-4">
              <Select
                defaultValue={selectedGeoGroup}
                onChange={setSelectedGeoGroup}
                options={geoGroupList}
              />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
            <div>
              <button
                class="w-full bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                onClick={updateGeofence}
              >
                Save
              </button>
            </div>

            <div>
              <button
                className={`w-full text-white font-bold py-2 px-4 rounded ${havePermissionDeleted ? "bg-red-500 hover:bg-red-700"
                    : "bg-gray-400 cursor-not-allowed"
                  }`}
                disabled={!havePermissionDeleted}
                onClick={deleteGeofence}
              >
                Delete
              </button>
            </div>
            <div>
              <button
                class="w-full bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 rounded"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapEditGeofenceModal;
